import { Position } from '@interfaces/client-account/client-account-models.interface';
import { CostBasisMethods } from '@interfaces/models/cost-basis-methods';

export interface FilteredCostBasisCoveredLot {
  lotID: string;
  aquiredDate: string;
  costperShare: number;
  marketValue: number;
  quantity: number;
  totalGainLoss: number;
}

export interface FormattedFilteredCostBasisCoveredLot extends FilteredCostBasisCoveredLot {
  formattedTotalGainLoss: string;
  formattedMarketValue: string;
}

export interface CostBasisMethodResponse {
  accounts: CostBasisMethodAccount[];
}

export interface CostBasisMethodAccount {
  accountId: number;
  holdings?: CostBasisMethodHolding[];
}

export interface CostBasisMethodHolding {
  holdingIdentifier: number;
  costBasisMethodCode: CostBasisMethods;
}

export interface CostBasisLotsResponse {
  asOfDate: string;
  coveredLots: CostBasisCoveredLot[];
  nonCoveredLots: any[];
  errors: any[];
}

export interface CostBasisCoveredLot {
  lotID: string;
  origLotID: string;
  quantity: number;
  costperShare: number;
  totalCost: number;
  marketValue: number;
  longTermGainLoss: number;
  totalGainLoss: number;
  perShareGainLoss: number;
  percentGainLoss: number;
  buyTransId: number;
  sellTransId: number;
  isLongPosition: boolean;
  ticker: string;
  aquiredDate: string;
  rollUp: boolean;
  rolledUpLots: any[];
  cusip: string;
  securityType: string;
  securityId: string;
  isVarious: boolean;
  isAverageCostChangePending: boolean;
  isUnrealized: boolean;
  hasUnallocated: boolean;
  hasDepreciatedGifts: boolean;
  event: string;
  costBasisMethod: string;
  hasUnrealizedLotWashSale: boolean;
  washSaleList: any[];
  term: string;
  maxitAccount: string;
  isGiftedBuy: boolean;
  description: string;
  isMissingMarketPrice: boolean;
  isBondHolding: boolean;
}

export interface CostBasisPosition extends Position {
  formattedBalance?: string;
  index?: number;
  giftingMethod?: string;
  selectedCostBasisMethod?: CostBasisMethods;
  shownCostBasisMethod?: CostBasisMethods;
  taxLots?: FilteredCostBasisCoveredLot[];
  taxLotsTotalShares?: string;
  taxLotsTotalMarketValue?: string;
  selectedAmount?: string | number;
  sharesTotalMarketValue?: string | number;
  additionalTaxLot?: FormattedFilteredCostBasisCoveredLot;
  sharesToTransfer?: string | number;
  estValueOfTransfer?: string | number;
  percentOfHolding?: string | number;
}
